module.exports = __webpack_public_path__ + "static/img/img1.fc8421d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/approve/img1.jpg
// module id = Atx7
// module chunks = 1